import React, {useMemo} from 'react';
import cn from 'classnames';

import {IProductPriceSalesProps} from './IProductPriceSales';

import styles from './ProductPriceSales.module.scss';

const ProductPriceSales = ({
	showSalesInParenthesis = true,
	percentage,
}: IProductPriceSalesProps) => {
	const priceSalesContent = useMemo(
		() => (
			<>
				{percentage}
				<span className="product-price__percentage-sign">&#37;</span>
			</>
		),
		[percentage]
	);

	if (!percentage) {
		return null;
	}

	return (
		<span className={cn('product-price__sales', styles['product-price__sales'])}>
			{showSalesInParenthesis ? (
				<>({priceSalesContent})</>
			) : (
				<>{priceSalesContent}</>
			)}
		</span>
	);
};

export default ProductPriceSales;
